export default __webpack_public_path__ + "static/media/services.8a38b390.png";